import { http } from "services/http";

import type {
  BulkWithdrawalResponse,
  JobRetryRequest,
  JobRetryResponse,
  TopupManageRequest,
  TransactionsListRequest,
  TransactionsListResponse,
  TransactionUpdateRequest,
  TransactionUpdateResponse,
  WithdrawalAcceptRequest,
  WithdrawalCancelRequest,
  WithdrawalsAcceptRequest,
  WithdrawalsCancelRequest,
  WithdrawalsRestartRequest,
} from "models/transactions.model";
import type { UserSelectOption, UsersSelectRequest } from "models/users.model";

export const transactionsApi = {
  getTransactionsData: (data?: TransactionsListRequest) =>
    http.quiet().post<TransactionsListResponse>("/api/transactions", data ? { ...data } : null),
  getUsersOpt: (data: UsersSelectRequest) =>
    http.quiet().post<UserSelectOption[]>("/api/get-users", { ...data }),
  updateTransaction: (data: TransactionUpdateRequest) =>
    http.quiet().post<TransactionUpdateResponse>("/api/transaction/update", { ...data }),

  manageTopup: (data: TopupManageRequest) =>
    http.quiet().post("/api/transactions/manage", { ...data }),
  acceptWithdrawal: (data: WithdrawalAcceptRequest) =>
    http.quiet().post("/api/transactions/accept_withdrawal", { ...data }),
  cancelWithdrawal: (data: WithdrawalCancelRequest) =>
    http.quiet().post("/api/transactions/cancel_withdrawal", { ...data }),

  acceptWithdrawals: (data: WithdrawalsAcceptRequest) =>
    http.quiet().post<BulkWithdrawalResponse>("/api/transactions/bunch_withdrawal_accept", { ...data }),
  cancelWithdrawals: (data: WithdrawalsCancelRequest) =>
    http.quiet().post<BulkWithdrawalResponse>("/api/transactions/bunch_withdrawal_cancel", { ...data }),
  restartWithdrawals: (data: WithdrawalsRestartRequest) =>
    http.quiet().post<BulkWithdrawalResponse>("/api/transactions/bunch_withdrawal_restart", { ...data }),

  retry: (data: JobRetryRequest) => http.quiet().post<JobRetryResponse>("/api/jobs/retry", { ...data }),
};
